import React from "react";
import Container from "../../components/ui/Container";
import { useLanguage } from "../../context/LanguageContext";
import { ReactComponent as QuranIcon } from "../../assets/telawah-assets/quranCardIcon.svg";
const FeatureCardSection = () => {
    const { language } = useLanguage();

    const content = {
        introduction: {
            en: "Here begins your journey with Telawa - the first step to a solid foundation in Islamic teachings and the Quran. A platform that will be your comprehensive guide for learning the Quran and Islamic teachings.",
            ar: "من هنا تبدأ رحلتك مع تلاوة - أول باب لتأسيس مضبوط في تعاليم الإسلام والقرآن الكريم. منصة ستكون دليلك الشامل لتعليم القرآن الكريم وتعاليم الإسلام.",
        },
        features: [
            {
                icon: "📖",
                title: { en: "High Quality Content", ar: "احصل على محتوى عالي الجودة" },
                description: {
                    en: "Receive reliable content designed for a deep understanding of Islam and the Quran, building a strong foundation.",
                    ar: "سوف تحصل على محتوى تعليمي موثوق يضمن لك فهمًا عميقًا للإسلام والقرآن الكريم وبناء أساس قوي.",
                },
            },
            {
                icon: "📚",
                title: { en: "Explore Courses", ar: "تصفح الدورات" },
                description: {
                    en: "A diverse selection of Sharia and educational courses, designed to deepen your understanding of Islam and enhance your life practically.",
                    ar: "مجموعة متنوعة ومميزة من الدورات الشرعية والتربوية، مصممة بعناية لتساعدك على الفهم العميق للإسلام وتطوير حياتك بأسلوب عملي ومفيد.",
                },
            },
        ],
    };

    return (
        <section
            className={`${
                language === "en" ? "ltr" : ""
            }  bg-white relative py-3 max-w-7xl mx-[2rem] md:mx-auto md:py-7 rounded-xl -mt-[2rem] md:-mt-[7rem] shadow-lg overflow-hidden`}
        >
            <div
                className={`${
                    language === "en" ? "-left-1/4" : "-right-1/4"
                } absolute top-0 bottom-0  w-full smooth max-w-[740px] bg-ashGray-50`}
                style={{ transform: "skew(-22deg, 0deg)" }}
            ></div>
            <Container>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
                    {/* Right Side: Introduction */}
                    <div
                        className={`col-span-1 text-center md:col-span-1 relative ${
                            language === "ar" ? "md:text-right" : "md:text-left"
                        } px-6`}
                    >
                        <p className="text-lg font-Amiri md:text-xl text-accentBlue leading-normal">
                            {content.introduction[language]}
                        </p>
                    </div>

                    {/* Left Side: Features Cards */}
                    <div className="col-span-1 relative md:col-span-2 mx-auto flex flex-col md:flex-row gap-6">
                        {content.features.map((feature, index) => (
                            <div
                                key={index}
                                className={`flex flex-col max-w-[300px] text-center p-6 rounded-md shadow-md ${
                                    language === "en" ? "en md:text-left" : "ar  md:text-right"
                                }`}
                            >
                                <QuranIcon className="w-16 h-16 mb-4" />
                                <h3 className="text-lg font-bold mb-2 text-gray-800">
                                    {feature.title[language]}
                                </h3>
                                <p className="text-gray-400 text-sm leading-relaxed">
                                    {feature.description[language]}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default FeatureCardSection;
